import React from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { HiDotsHorizontal } from "react-icons/hi";
import { capitalizeFirstLetter } from '../../shared/helpers/helpers';
import { Link } from 'react-router-dom';

interface SmashTableActionProps<T = any> {
    tableActions: TableActionItem[];
    item: T; // TO FIX
    children?: React.ReactNode;
}

export interface TableActionItem<T = any> {
    name: string,
    url?: (item: T) => string,
    actionComponent?: (props: SmashTableActionProps<T>) => React.ReactNode
}

const SmashTableAction = (props: SmashTableActionProps) => {

    const handleSelect = (action: any) => {
    }

    return (
        <Dropdown>
            <DropdownButton title={<HiDotsHorizontal />} variant='light' onSelect={handleSelect} >
                {props.tableActions.map((itemAction, idx) => {
                    const { name, actionComponent, url } = itemAction;
                    if (url) {
                        return (
                            <Dropdown.Item as={Link} key={idx} eventKey={name} to={url(props.item)}>
                                {capitalizeFirstLetter(name)}
                            </Dropdown.Item>
                        )
                    }
                    if (actionComponent && actionComponent(props)) {
                        return (
                            <Dropdown.Item key={idx} eventKey={itemAction.name}>
                                {/* TO DO Dynamically load the proper component (eg. Delete / Edit / ... ) */}
                                {actionComponent(props)}
                            </Dropdown.Item>
                        )
                    }
                })}
            </DropdownButton>
        </Dropdown>
    )
}

export default SmashTableAction